<template>
  <div>
    <tablegeneric
      :headers="headers"
      :formfields="formfields"
      url="/seguranca/device"
      tela="acesso_dispositivos"
      editar="acesso_dispositivos_editar"
      excluir="acesso_dispositivos_excluir"
      exportar="acesso_dispositivos_exportar p/excel"
      imprimir="acesso_dispositivos_imprimir"
      clonar="acesso_dispositivos_clonar"
    />
  </div>
</template>

<script>
import headers from './headers.mixins'
import formfields from './formfields.mixins'

export default {
  name: 'Home',
  components: {
    tablegeneric: () => import('@/components/tablegeneric')
  },
  mixins: [
    headers,
    formfields
  ]
}
</script>

<style>
</style>
